
export default {
  setPaymentStatusSorts (state, data) {
    state.paymentStatusSorts = data
  },
  setPaymentInfoStatusSorts (state, data) {
    state.paymentInfoStatusSorts = data
  },
  clearPaymentDropDownList (state) {
    state.paymentStatusSorts = []
    state.paymentInfoStatusSorts = []
  }
}



// WEBPACK FOOTER //
// ./src/store/payment/mutations.js